<template>
  <div
    :class="{
      'mt-26 md:mt-32 lg:mt-44': showTopMargin,
    }"
  >
    <ComponentBuilder
      :items="items"
      :is-kiosk="isKiosk"
      :cinema-hall-type="cinemaHallType"
      :cinema-hall-type-uri="cinemaHallTypeUri"
      :cinema-hall-tags="cinemaHallTags"
      use-main-headline-typography
    />
  </div>
</template>

<script setup lang="ts">
import ComponentBuilder from "~/components/ComponentBuilder.vue";

const COLLAPSED_TYPE_HANDLES = ["weekMovie", "carousel"];
const COLLAPSED_TYPE_NAMES = [
  "componentsBuilder_embeddedMovieDetail_BlockType",
];

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  isKiosk: {
    type: Boolean,
    default: false,
  },
  collapsedTop: {
    type: Boolean,
    default: false,
  },
  cinemaHallType: {
    type: Object,
    default: null,
  },
  cinemaHallTypeUri: {
    type: String,
    default: null,
  },
  cinemaHallTags: {
    type: Array,
    default: () => [],
  },
});

const showTopMargin = computed(() => {
  if (props.collapsedTop) {
    return false;
  }

  const typeHandle = props.items?.[0]?.items?.[0]?.typeHandle;
  const typename = props.items?.[0]?.__typename;

  if (COLLAPSED_TYPE_HANDLES.includes(typeHandle)) {
    return false;
  }

  if (COLLAPSED_TYPE_NAMES.includes(typename)) {
    return false;
  }

  return true;
});
</script>
